import { render } from "./BookRegister.vue?vue&type=template&id=1cee955a&scoped=true"
import script from "./BookRegister.vue?vue&type=script&lang=js"
export * from "./BookRegister.vue?vue&type=script&lang=js"

import "./BookRegister.vue?vue&type=style&index=0&id=1cee955a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cee955a"]])

export default __exports__